/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S8_C_Li1Inputs */

const tr_mesafeli_s8_c_li1 = /** @type {(inputs: Mesafeli_S8_C_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`18 yaşını doldurmuş ve fiil ehliyetine sahip olmak.`)
};

const en_mesafeli_s8_c_li1 = /** @type {(inputs: Mesafeli_S8_C_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To have completed the age of 18 and to have legal capacity.`)
};

const de_mesafeli_s8_c_li1 = /** @type {(inputs: Mesafeli_S8_C_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das 18. Lebensjahr vollendet haben und geschäftsfähig sein.`)
};

const ru_mesafeli_s8_c_li1 = /** @type {(inputs: Mesafeli_S8_C_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Достичь 18 лет и обладать дееспособностью.`)
};

/**
* | output |
* | --- |
* | "To have completed the age of 18 and to have legal capacity." |
*
* @param {Mesafeli_S8_C_Li1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s8_c_li1 = /** @type {((inputs?: Mesafeli_S8_C_Li1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S8_C_Li1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s8_c_li1(inputs)
	if (locale === "de") return de_mesafeli_s8_c_li1(inputs)
	if (locale === "ru") return ru_mesafeli_s8_c_li1(inputs)
	return tr_mesafeli_s8_c_li1(inputs)
});